import React, { useState, useEffect } from "react";

import { Link } from "react-router-dom";

import { Alert } from "reactstrap";

import ProfileMenu from "../../Components/CommonForBoth/TopBarDropDown/ProfileMenu";
import NotificationDropDown from "../../Components/CommonForBoth/NotificationDropDown";

import logo from "../../assets/images/darklogo.png";
import logoLightSvg from "../../assets/images/whitelogo.png";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { fetchCustomerProfile } from "../../slices/customerProfile/thunk";
import { withTranslation } from "react-i18next";

const Header = (props: any) => {

  const dispatch = useDispatch<any>();

  const selectCustomerProfile = createSelector(
    (state: any) => state.CustomerProfile,
    (cp) => ({ cstpack: cp.cstpack })
  );
  const { cstpack: cstpacck } = useSelector(selectCustomerProfile);

  const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
  const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
      if (reason === "clickaway") { return; } 
      setAlertMsgg({ ...alertMsgg, open: false }) 
  };
  const [cartLength, setCartLength] = useState(0);

  useEffect(() => {
    if (localStorage.getItem('userole_') === "cst") {
      dispatch(fetchCustomerProfile());
    }
  }, [dispatch]);

  useEffect(() => {
    setCartLength(parseInt(localStorage.getItem("cart_length") || "0"));
    const updateCartLength = () => {
      setCartLength(parseInt(localStorage.getItem("cart_length") || "0"));
    };
    window.addEventListener("cartLengthUpdated", updateCartLength);
    window.addEventListener("focus", updateCartLength);
    return () => {
      window.removeEventListener("cartLengthUpdated", updateCartLength);
      window.removeEventListener("focus", updateCartLength);
    };
  }, []);

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }



  const userRole = localStorage.getItem("userole_");

  return (
    <React.Fragment>
      {alertMsgg.open && (
          <Alert 
              color={alertMsgg.type === "success" ? "success" : "danger"} 
              toggle={handleAlertMsggClose}
              style={{ fontWeight: "bold" }}
          >
              {alertMsgg.content}
          </Alert>
      )}
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box d-lg-none d-md-block">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoLightSvg} alt="" height="40" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              onClick={() => tToggle()}
              className="btn btn-sm px-3 font-size-16 header-item "
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>

            
          </div>
          <div className="d-flex gap-3 align-items-center">

            {/* FREE_PLATFORM_MODE: Subscribe button hidden. To restore: uncomment and re-enable fetch_experts + subscription modal */}

            {userRole === "cst" && (
              <Link to="/cbookinggroup" className="">
                <button className="btn header-item noti-icon position-relative font-size-14">
                  <i className="bx bx-cart"></i>
                  {cartLength > 0 && (
                    <span className="badge bg-danger rounded-pill">{cartLength}</span>
                  )}
                </button>
              </Link>
            )}

            <NotificationDropDown />

            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};


export default withTranslation()(Header);
